
import { TimeSlot, DayOfWeek } from "@/models/Schedule";

// Mock time slots
export const timeSlots: TimeSlot[] = [
  // Monday slots
  {
    id: "ts1",
    day: "monday" as DayOfWeek,
    startTime: "09:00",
    endTime: "10:00",
    workoutTypeId: "wt1", // Pilates
    maxClients: 10,
    isRecurring: true,
    isActive: true,
  },
  {
    id: "ts2",
    day: "monday" as DayOfWeek,
    startTime: "17:00",
    endTime: "18:00",
    workoutTypeId: "wt2", // HIIT
    maxClients: 12,
    isRecurring: true,
    isActive: true,
  },
  
  // Tuesday slots
  {
    id: "ts3",
    day: "tuesday" as DayOfWeek,
    startTime: "10:00",
    endTime: "11:00",
    workoutTypeId: "wt3", // Yoga
    maxClients: 15,
    isRecurring: true,
    isActive: true,
  },
  
  // Wednesday slots
  {
    id: "ts4",
    day: "wednesday" as DayOfWeek,
    startTime: "18:00",
    endTime: "19:00",
    workoutTypeId: "wt4", // Strength Training
    maxClients: 8,
    isRecurring: true,
    isActive: true,
  },
  {
    id: "ts5",
    day: "wednesday" as DayOfWeek,
    startTime: "19:15",
    endTime: "20:15",
    workoutTypeId: "wt1", // Pilates
    maxClients: 10,
    isRecurring: true,
    isActive: true,
  },
  
  // Thursday slots
  {
    id: "ts6",
    day: "thursday" as DayOfWeek,
    startTime: "07:00",
    endTime: "08:00",
    workoutTypeId: "wt2", // HIIT
    maxClients: 12,
    isRecurring: true,
    isActive: true,
  },
  
  // Friday slots
  {
    id: "ts7",
    day: "friday" as DayOfWeek,
    startTime: "16:30",
    endTime: "17:30",
    workoutTypeId: "wt3", // Yoga
    maxClients: 15,
    isRecurring: true,
    isActive: true,
  },
  
  // Saturday slots
  {
    id: "ts8",
    day: "saturday" as DayOfWeek,
    startTime: "09:00",
    endTime: "10:00",
    workoutTypeId: "wt1", // Pilates
    maxClients: 10,
    isRecurring: true,
    isActive: true,
  },
];
